// removed by extract-text-webpack-plugin
module.exports = {"Navigation":"_3jIYv","Wrapper":"_1xmOw","Primary":"_1eZiy","Secondary":"_1FkKW","SecondaryMobile":"_3Bo2p","Inner":"_30FQA","ProceedContainer":"_3PZjp","CloseButton":"_KOcdZ","ErrorBox":"_4rRh4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Review/Review.scss
// module id = 362
// module chunks = 0